import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiActivity, FiAperture, FiCommand, FiHexagon, FiLayers } = FiIcons;

function Clients() {
  const clients = [
    { name: 'Northstar', icon: FiActivity },
    { name: 'Bloom', icon: FiAperture },
    { name: 'Arc Studio', icon: FiCommand },
    { name: 'Wellwise', icon: FiHexagon },
    { name: 'Foundry', icon: FiLayers }
  ];

  return (
    <section className="clients-section panel-section" id="clients">
      <p>Helping ambitious teams protect their most valuable resource — time.</p>
      <div className="client-row">
        {clients.map((client) => (
          <span key={client.name}><SafeIcon icon={client.icon} />{client.name}</span>
        ))}
      </div>
    </section>
  );
}

export default Clients;